"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKEN_REGEX = exports.TOKEN_NOT_FOUND_CSS_VAR = exports.STENCIL_TOKENS_NAMESPACE = exports.PREFERS_COLOR_SCHEME_ID = exports.PREFERS_COLOR_SCHEME_DARK_SELECTOR = exports.PREFERS_COLOR_SCHEME_DARK = void 0;
const STENCIL_TOKENS_NAMESPACE = exports.STENCIL_TOKENS_NAMESPACE = 'st-dt';
const TOKEN_NOT_FOUND_CSS_VAR = exports.TOKEN_NOT_FOUND_CSS_VAR = "--".concat(STENCIL_TOKENS_NAMESPACE, "-token-not-found");
const PREFERS_COLOR_SCHEME_DARK = exports.PREFERS_COLOR_SCHEME_DARK = 'dark';
const PREFERS_COLOR_SCHEME_ID = exports.PREFERS_COLOR_SCHEME_ID = 'data-stencil-prefers-color-scheme';
const PREFERS_COLOR_SCHEME_DARK_SELECTOR = exports.PREFERS_COLOR_SCHEME_DARK_SELECTOR = "[".concat(PREFERS_COLOR_SCHEME_ID, "=").concat(PREFERS_COLOR_SCHEME_DARK, "]");
const TOKEN_REGEX = exports.TOKEN_REGEX = /^[a-z]+(\.[a-z0-9-]+)+$/i;